<template>
  <div>
    <div class="flexarea">
      <!--左边题目编号区-->
      <transition name="slider-fade">
        <div class="left">
          <div class="l-bottom">
            <div class="item">
              <p class="total_score"><b>总分:{{parentData.total_score}}</b></p>
              <p class="pass_score"><b>及格:{{parentData.pass_score}}</b></p>
            </div>
          </div>
          <ul class="l-top">
            <li>
              <a href="javascript:;"></a>
              <span>未答</span>
            </li>
            <li>
              <a href="javascript:;"></a>
              <span>已答</span>
            </li>
          </ul>
          <div class="l-bottom">
            <div class="item">
              <div>
                <el-row>
                  <ul>
                    <li v-for="(item, index) in parentData.itemList" :key="item.id">
                      <el-button v-if="!item.answer && index != this.page" class="unalready" @click="goToProblem(index)">{{index+1}}</el-button>
                      <el-button v-if="item.answer && index != this.page" class="already" @click="goToProblem(index)">{{index+1}}</el-button>
                      <el-button v-if="!item.answer && index == this.page" class="unalready_now" @click="goToProblem(index)">{{index+1}}</el-button>
                      <el-button v-if="item.answer && index == this.page" class="already_now" @click="goToProblem(index)">{{index+1}}</el-button>
                    </li>
                  </ul>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!--右边选择答题区-->
      <transition name="slider-fade">
        <el-card class="right">
          <div  v-for="(item,index) in parentData.itemList" :key="item.id" class="content">
            <div v-if="index == page">
              <div class="single" v-if="item.question_type == 'single'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber" >{{index +1}}</span></li>
                    <li><span class="question_typeSingle">单选题</span></li>
                    <li><span class="score">( {{item.score}} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{item.topic}}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px" :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-radio-group v-model="item.answer" class="choice" size="large" @change="setAnswer(item)">
                  <el-radio v-if="item.option_a != null" :label="'option_a'" size="large">A. {{item.option_a}}</el-radio>
                  <el-radio v-if="item.option_b != null" :label="'option_b'" size="large">B. {{item.option_b}}</el-radio>
                  <el-radio v-if="item.option_c != null" :label="'option_c'" size="large">C. {{item.option_c}}</el-radio>
                  <el-radio v-if="item.option_d != null" :label="'option_d'" size="large">D. {{item.option_d}}</el-radio>
                  <el-radio v-if="item.option_e != null" :label="'option_e'" size="large">E. {{item.option_e}}</el-radio>
                  <el-radio v-if="item.option_f != null" :label="'option_f'" size="large">F. {{item.option_f}}</el-radio>
                </el-radio-group>
              </div>
              <div class="fill" v-if="item.question_type == 'multiple'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber" >{{index +1}}</span></li>
                    <li><span class="question_typeFill">多选题</span></li>
                    <li><span class="score">( {{item.score}} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{item.topic}}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px" :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-checkbox-group v-model="item.answer" class="choice" size="large" @change="setAnswer(item)">
                  <el-checkbox v-if="item.option_a != null" :label="'option_a'" size="large">A. {{item.option_a}}</el-checkbox>
                  <el-checkbox v-if="item.option_b != null" :label="'option_b'" size="large">B. {{item.option_b}}</el-checkbox>
                  <el-checkbox v-if="item.option_c != null" :label="'option_c'" size="large">C. {{item.option_c}}</el-checkbox>
                  <el-checkbox v-if="item.option_d != null" :label="'option_d'" size="large">D. {{item.option_d}}</el-checkbox>
                  <el-checkbox v-if="item.option_e != null" :label="'option_e'" size="large">E. {{item.option_e}}</el-checkbox>
                  <el-checkbox v-if="item.option_f != null" :label="'option_f'" size="large">F. {{item.option_f}}</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="judge" v-if="item.question_type == 'judge'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber" >{{index +1}}</span></li>
                    <li><span class="question_typeJudge">判断题</span></li>
                    <li><span class="score">( {{item.score}} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{item.topic}}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px" :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-radio-group v-model="item.answer" class="choice" size="large" @change="setAnswer(item)">
                  <el-radio :label="'correct'" size="large">是</el-radio>
                  <el-radio :label="'fault'" size="large">否</el-radio>
                </el-radio-group>
              </div>
              <div class="operation">
                <ul class="end">
                  <li @click="previous()" v-if="index != 0" :class="index == 1 ? 'next' : 'before-next'">
                    <span>上一题</span></li>
                  <li @click="toNext()" v-if="index != parentData.itemList.length-1 && item.answer" :class="index == 0 ? 'next' : 'before-next'">
                    <span>下一题</span>
                  </li><li  @click="over()" v-if="index === parentData.itemList.length-1 && item.answer" :class="index == 0 ? 'next' : 'before-next'">
                    <span>提交</span></li>
                </ul>
              </div>
            </div>
          </div>
        </el-card>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnswerView",
  inject: ['$fn'],
  props:{
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data(){
    return{
      // 当前页
      page: 0,
      index: 0, //全局index
    }
  },
  methods:{

    //下一题
    toNext() {
      this.index ++;
      this.page ++;
    },

    //上一题
    previous() {
      this.index --;
      this.page --;
    },

    //点击左边题号显示题的内容
    async goToProblem(index) {
      this.index = index + 1;
      this.page = index;
    },

    //最后一题提交计算分数
    async over() {
      this.parentData.status = "已完成";
      this.parentData.score = await this.$http('ihtExamService.getScoreSum', this.parentData);
      this.$message.success("交卷成功11111");
      this.$fn.closeWindow()
    },

    //添加答案
    setAnswer(item){
      this.$http('ihtExamService.putAnswer', item)
    },

  },
}
</script>

<style scoped>

</style>